/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// apiUrl: 'http://163.53.85.48:7073/fixed-assets-management-0.0.1-SNAPSHOT', //   ,
export const environment = {
  production: true,

  // apiUrl: 'http://localhost:7065',
 
  // apiUrl: 'http://localhost:7060', 
  
 /////////////////// live domain ////////////

 apiUrl:'https://api.postprop.in/payroll',   
 
///////////////// test domain

//  apiUrl:'https://api.postprop.in/payroll_live',   

// apiUrl: 'http://163.53.85.48:7069/erpfa',


// apiUrl:'http://88.99.162.203:8080/payroll',  

// geolocattion gateway
// apiUrl:'https://api.postprop.in/redis-test-payroll',  


};
 

